export default __webpack_public_path__ + "static/media/twitter.ac22420b.svg";